"use client"

import { getCookie, removeCookie, setCookie, type CookieOptions } from "@/utils/cookie-helper"
import type { PersistStorage, StorageValue } from "zustand/middleware"

export interface CookieStorageOptions extends CookieOptions {
  defaultExpireDays?: number
}

/**
 * Tạo cookie storage adapter cho zustand persist
 */
export const createCookieStorage = <T = any>(options: CookieStorageOptions = {}): PersistStorage<T> => {
  const { defaultExpireDays = 30, ...cookieOptions } = options

  const getDefaultExpires = () => {
    const date = new Date()
    date.setTime(date.getTime() + defaultExpireDays * 24 * 60 * 60 * 1000)
    return date
  }

  return {
    getItem: (name: string) => {
      try {
        const value = getCookie(name)
        return value ? JSON.parse(value) : null
      } catch (error) {
        console.error(`Error getting cookie ${name}:`, error)
        return null
      }
    },

    setItem: (name: string, value: StorageValue<T>) => {
      try {
        const finalOptions: CookieOptions = {
          expires: getDefaultExpires(),
          path: "/",
          sameSite: "lax",
          ...cookieOptions,
        }

        setCookie(name, JSON.stringify(value), finalOptions)
      } catch (error) {
        console.error(`Error setting cookie ${name}:`, error)
      }
    },

    removeItem: (name: string) => {
      try {
        removeCookie(name, {
          path: cookieOptions.path || "/",
          domain: cookieOptions.domain,
        })
      } catch (error) {
        console.error(`Error removing cookie ${name}:`, error)
      }
    },
  }
}

export const cookieStorage = createCookieStorage({
  defaultExpireDays: 7,
  path: "/",
  sameSite: "lax",
})
